import { Button, Modal } from "@legal-500/legal500-design-system";
import { useState } from "react";
import { dbManagerService } from "../../../api/dbManager.service.js";
import styles from "./DbManager.module.css";

type RemoveKeyspaceModalProps = {
  isOpen: boolean;
  keyspace: string;
  family: string;
  onClose: () => void;
  onRemoved: () => void;
};

export function RemoveKeyspaceModal({
  isOpen,
  keyspace,
  family,
  onClose,
  onRemoved,
}: RemoveKeyspaceModalProps) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleConfirm = async () => {
    setSubmitting(true);
    setError(null);
    try {
      await dbManagerService.removeKeyspace(keyspace, family);
      onRemoved();
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`Remove slot ${keyspace}`}
      size="small"
      blurBackground
    >
      <div className={styles.modalBody}>
        {error && <div className={styles.errorBanner}>{error}</div>}

        <p>
          This will clear all keys for <code>{keyspace}</code> and remove it from the authoritative
          slot directory. After removal, the slot will no longer appear in Db Manager until it is
          created again.
        </p>

        <div className={styles.actions}>
          <Button variant="text" color="default" onClick={onClose} disabled={submitting}>
            Cancel
          </Button>
          <Button variant="contained" color="error" onClick={handleConfirm} disabled={submitting}>
            {submitting ? "Removing..." : "Remove slot"}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
